import React, { Component } from 'react';

import { Card, Row, Col, Progress, Skeleton } from 'antd';

import './ClientCard.css';
import { observer, inject } from 'mobx-react';
import SubscriptionDate from './SubscriptionDate';

const percentage = (value, total) => {
  if (total === 0) {
    return '0%';
  }
  return `${Math.round((100 * value) / total)}%`;
};

const FidelitySummary = props => (
  <Col span={props.span} className="FidelitySummary">
    <div style={{ fontSize: '0.8rem' }}>
      <div
        style={{
          width: '20px',
          height: '20px',
          lineHeight: '20px',
          textAlign: 'center',
          background: `${props.color}`,
          border: `1px solid ${props.color}`,
          borderRadius: '100%',
          marginRight: '5px',
          color: '#ffffff',
          fontWeight: '700'
        }}
      >
        {props.value}
      </div>
      {props.total !== undefined && <div style={{ textAlign: 'center', lineHeight: '1' }}>{percentage(props.value, props.total)}</div>}
    </div>
    <div className="label" style={{ height: '25px', lineHeight: '25px', borderRadius: '15px', padding: '0 10px 0 0' }}>
      {props.label}
    </div>
  </Col>
);

@inject('translationsStore')
@observer
export default class ClientCard extends Component {
  render() {
    const { translationsStore } = this.props;
    return (
      <Card className="ClientCard" style={this.props.style} bodyStyle={{ height: '100%' }}>
        <Skeleton loading={!this.props.fullName}>
          <Row style={{ display: 'flex', height: '100%' }}>
            {/*client info*/}
            <div style={{ width: '50%' }} className="clientInfo">
              <div>
                <Col className="title" title={this.props.fullName}>
                  <strong>{this.props.fullName}</strong>
                </Col>
              </div>
              <div>
                <Col className="subtitle">
                  <strong>{this.props.mobile}</strong>
                </Col>
                <Col>{this.props.email}</Col>
                {this.props.address && (
                  <Col>
                    {this.props.address.road}, {this.props.address.number}
                  </Col>
                )}
                {this.props.address && (
                  <Col>
                    {this.props.address.postcode}, {this.props.address.city} - {this.props.address.country}
                  </Col>
                )}
              </div>
              <div className="subscription">
                <SubscriptionDate subscriptionStart={this.props.subscriptionStart} subscriptionEnd={this.props.subscriptionEnd} />
              </div>
            </div>

            <div className="Fidelity" style={{ marginLeft: '15px' }}>
              {!!this.props.fidelity && (
                <div className="fidelityInner">
                  <div className="title">
                    <strong>Fidelity Index</strong>
                    <Progress
                      className={`${100 * this.props.fidelity.fidelityIndex < 30 ? 'red' : 100 * this.props.fidelity.fidelityIndex < 70 ? 'orange' : 'green'}`}
                      type="dashboard"
                      strokeColor="#63c25b"
                      percent={Math.round(100 * this.props.fidelity.fidelityIndex)}
                      strokeWidth={12}
                      width={100}
                      style={{ marginRight: '5px', textAlign: 'center' }}
                      format={percent => percent + '%'}
                    />
                  </div>
                  <div className="fidelitySummaries">
                    <div className="column">
                      <FidelitySummary color="#767676" value={this.props.fidelity.total} label={translationsStore.translate('carView.client.total')} />
                      <FidelitySummary
                        color="#fdcb57"
                        total={this.props.fidelity.total}
                        value={this.props.fidelity.suspended}
                        label={translationsStore.translate('lead.status.suspended')}
                      />
                      {/* </div>
                    <div className="column"> */}
                      <FidelitySummary
                        color="#1ba610"
                        total={this.props.fidelity.total}
                        value={this.props.fidelity.booked}
                        label={translationsStore.translate('lead.status.booked')}
                      />
                      <FidelitySummary
                        color="#fd5757"
                        total={this.props.fidelity.total}
                        value={this.props.fidelity.discarded}
                        label={translationsStore.translate('lead.status.discarded')}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Row>
        </Skeleton>
      </Card>
    );
  }
}
